import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useSidebarContext } from './SidebarContext';
import { useTheme } from '../../../contexts/ThemeContext';
import { getThemedStyles } from './styles';
import { toPinyin } from '../../../utils/pinyin';

/**
 * 侧边栏搜索组件
 */
const SidebarSearch = () => {
  const { searchKeyword, setSearchKeyword, collapsed } = useSidebarContext();
  const { isDark } = useTheme();
  const themedStyles = getThemedStyles(isDark);
  
  // 折叠状态下不显示搜索框
  if (collapsed) return null;
  
  return (
    <div style={themedStyles.searchContainerStyle}>
      <Input
        placeholder={'搜索菜单...'}
        prefix={<SearchOutlined style={{ color: themedStyles.colors.textTertiary }} />}
        value={searchKeyword}
        onChange={(e) => setSearchKeyword(e.target.value)}
        allowClear
        size="small"
      />
    </div>
  );
};

/**
 * 搜索匹配函数 - 支持中文和拼音首字母
 * @param {string} label - 菜单标签
 * @param {string} keyword - 搜索关键词
 * @returns {boolean} - 是否匹配
 */
export const matchSearch = (label, keyword) => {
  if (!keyword) return true;
  
  const lowerKeyword = keyword.toLowerCase();
  const lowerLabel = label.toLowerCase();
  
  // 直接匹配
  if (lowerLabel.includes(lowerKeyword)) return true;
  
  // 拼音首字母匹配
  const pinyinInitials = toPinyin(label);
  if (pinyinInitials.toLowerCase().includes(lowerKeyword)) return true;
  
  return false;
};

export default SidebarSearch;
